import { useConfirm } from 'material-ui-confirm'
import React from 'react'
import { Profile, Subscription } from '../../../../Profile/types'
import { UnitMaster } from '../../../../Units/reducer'
import {
  ConfirmationButtonProps,
  ContentProps,
  DialogActionProps,
  TitleProps,
} from '../../config'
import { CancelSubscriptionDescription } from './description'
import { onConfirmCancelSubscriptionCallback } from './onConfirm'

export const onCancelSubscriptionCallback = ({
  selectedRow,
  profile,
  subscriptions,
  onCloseUnitModal,
}: {
  selectedRow: UnitMaster | null
  profile: Profile
  subscriptions: Subscription[]
  onCloseUnitModal: () => void
}) => {
  const confirm = useConfirm()

  const { onConfirmCancelSubscription } = onConfirmCancelSubscriptionCallback({
    selectedRow,
    profile,
    subscriptions,
    onCloseUnitModal,
  })

  const onCancelSubscription = React.useCallback(() => {
    confirm({
      title: (
        <div>
          Cancel Subscription <b>#{selectedRow?.subscriptionId}</b>
        </div>
      ),
      description: <CancelSubscriptionDescription selectedRow={selectedRow} />,
      titleProps: TitleProps,
      dialogActionsProps: DialogActionProps,
      contentProps: ContentProps,
      confirmationButtonProps: ConfirmationButtonProps,
    })
      .then(() => {
        onConfirmCancelSubscription()
      })
      .catch(() => {
        console.log('canceled')
      })
  }, [confirm, selectedRow, onConfirmCancelSubscription])

  return {
    onCancelSubscription,
  }
}
